var topBanner = (function() {
"use strict";

	// Privates
	var banner = $('.banner-carousel');

	$('#main').on('click', '.banner-carousel button', function() {
		banner.hide();
	});
})();